import React, { Component } from 'react'
import PropTypes from 'prop-types'

// import { translation } from '../../../../utils/helpers'

import Panel from '../../../elements/panel'

class ReferenceContactInfo extends Component {
  render () {
    const { title, icon, name, address, phone, onlyName } = this.props

    return (
      <Panel title={title} icon={icon}>
        <label className='full'>{name}</label>
        {!onlyName && <label>{address}</label>}
        {!onlyName && <label>{phone}</label>}
      </Panel>
    )
  }
}

ReferenceContactInfo.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired
}

ReferenceContactInfo.defaultProps = {
  title: null,
  icon: null
}

export default ReferenceContactInfo



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceContactInfo/index.js